// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app/dist/global";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";
import { getStatisticsTotal } from "services/Utils";

export const getExcelData = (
  data: any,
  parsedData: any,
  parsedDataNoCollege: any,
  variables: any,
) => {
  if (parsedData.length === 0) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: I18n.get.languageRepresentativeDiploma.label
      .toLowerCase()
      .replaceAll(" ", "_"),
    sheets: [],
  };
  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.languageRepresentativeDiploma.label,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data.certStatisticsLanguageRepresentativeDiplomas.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [
      I18n.trans(I18n.get.vocertStatistics.perItem, {
        item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
      }),
    ],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      getStatisticsTotal(parsedData) + parsedDataNoCollege.length,
    ],
  ];

  let byGroupSheet: Sheet = {
    name: I18n.trans(I18n.get.vocertStatistics.perItem, {
      item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
    }),
    rows: [...commonHead],
  };

  byGroupSheet.rows?.push([
    {
      richText: [
        {
          font: {
            size: 10,
            bold: true,
          },
          text: I18n.get.vocertStatistics.withoutLocalRegion,
        },
      ],
    },
    "",
    parsedDataNoCollege.length,
  ]);

  parsedData.forEach((v: GeneralObject) => {
    let title = v.title;
    if (v.note) {
      title = `${title}\n${v.note}`;
    }
    byGroupSheet.rows?.push([
      {
        richText: [
          {
            font: {
              size: 10,
            },
            text: title,
          },
        ],
      },
      "",
      v.total,
    ]);
  });

  result.sheets?.push(byGroupSheet);

  return result;
};
